function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333331;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dark_Grey_Shizzz",
  "data-name": "Dark Grey Shizzz"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M201.51,139.75,269,127.19l-68.42-5.78L262.21,91.1,194.76,104l51.16-45.8L184.45,88.8l36.9-57.91L170.43,77l19.9-65.71L153.72,69.33,155.16.68,135.58,66.49,118.44,0l-1.09,68.66L82.91,9.25l17.46,66.41L51.18,27.75,85.92,87,25.63,54.12l49.43,47.67L8.13,86.41,68.59,119,0,122.22l67,15L1.83,158.9l68.57-3.59L13.49,193.72l65.06-22L34.11,224.11l56.72-38.7-28.67,62.4,44.18-52.57L95.57,263.06l28.36-62.54,7.92,68.21,10.43-67.87,26,63.54-8.27-68.17,42.21,54.16L175.92,187l55.25,40.76-42.48-54,64.21,24.35-55.46-40.49,68.39,6.12ZM130,146.42l-13.41-1.74-4,31-8.94-1.16,4-31-13.41-1.74,1-8.1L131,138.32Zm-9.69-14.6-13-1.69L98,89.14l9.73,1.27,7,33.69L130,93.32l9.72,1.26Zm47.59,19.53-21.29-2.77-.91,7,19.61,2.55-1,8.1-19.61-2.55-1,7.82,21.85,2.84-1.06,8.11-30.78-4,5.08-39.11,30.23,3.93Zm10.09-31.91a20.86,20.86,0,1,1-18.06-22.81A20.51,20.51,0,0,1,177.94,119.44ZM158.79,105c-6.43-.83-12.32,2.95-13.26,10.21s3.78,12.43,10.21,13.26,12.31-2.94,13.26-10.21S165.22,105.85,158.79,105Z"
})));

var SvgVote = function SvgVote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 269.01 268.73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Vote.99209e47.svg";
export { ForwardRef as ReactComponent };